<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <material-card
      v-if="dialog"
      :offset="10"
      :full-width="true"
      color="green"
      title="Kpi Category"
      text="Delete Kpi Category"
      class="mb-0"
    >
      <v-card-text> Are you sure you want to delete <b>{{ category.name.toUpperCase() }}</b> category? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="setDialog(false)"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        progressing: false,
        category: null,
      }
    },
    methods: {
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      toggleDialog (category) {
        this.category = { ...category }

        this.setDialog(true)
      },
      submitForm () {
        this.setProgressing(true)

        this.$api.kpiCategories().delete(this.category.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(error => {
            if (error.response.status === 405) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })
            }
          })
          .then(() => {
            this.setProgressing(false)
            this.setDialog(false)
          })
      },
    },
  }
</script>
